<div class="orders-filter">
  <mat-form-field>
    <mat-label>Select Store Name</mat-label>
    <mat-select placeholder=""
                class="order-st-select"
                [(ngModel)]="orderFilter.storeId"
                (selectionChange)="searchEvent(true)">
      <mat-option [value]="0">
        All
      </mat-option>
      <mat-option [value]="-1">
        Order desk
      </mat-option>
      <mat-option *ngFor="let item of storeList; let i=index"
                  [value]="item.StoreId">
        {{item.StoreName}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  


  <div>
    <mat-form-field class="example-full-width">
      <mat-label>By Order#</mat-label>
      <input matInput placeholder="" type="text"
            [(ngModel)]="orderFilter.orderNumber"
            ng-model-options="{debounce: 10000}"
            (change)="searchEvent(true)">
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>By Product, Name, Address</mat-label>
      <input matInput placeholder="" type="text"
            [(ngModel)]="orderFilter.orderedUserName"
            ng-model-options="{debounce: 10000}"
            (change)="searchEvent(true)">
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>By Email</mat-label>
      <input matInput placeholder="" type="text"
            [(ngModel)]="orderFilter.orderUserEmail"
            ng-model-options="{debounce: 10000}"
            (change)="searchEvent(true)">
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>Select Order Status</mat-label>
      <mat-select [(ngModel)]="orderFilter.orderStatus"
                  placeholder=""
                  (selectionChange)="searchEvent(true)">
        <mat-option [value]="0">All</mat-option>
        <mat-option [value]="1">Ordered</mat-option>
        <mat-option [value]="2">Confirmed</mat-option>
        <mat-option [value]="3">Processing</mat-option>
        <mat-option [value]="5">Shipped</mat-option>
        <mat-option [value]="6">Delivered</mat-option>
        <mat-option [value]="4">Cancelled</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>By Style</mat-label>
      <input matInput placeholder="" type="text"
            [(ngModel)]="orderFilter.style"
            ng-model-options="{debounce: 10000}"
            (change)="searchEvent(true)">
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <mat-label>Start order date</mat-label>
      <input [max]="orderFilter.endDate" matInput [matDatepicker]="startpicker" placeholder="" (dateChange)="searchEvent(true)"
      [(ngModel)]="orderFilter.startDate">
      <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
      <mat-datepicker #startpicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <mat-label>End order date</mat-label>
      <input [min]="orderFilter.startDate" matInput [matDatepicker]="endpicker" placeholder="" (dateChange)="searchEvent(true)"
      [(ngModel)]="orderFilter.endDate">
      <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
      <mat-datepicker #endpicker></mat-datepicker>
    </mat-form-field>
      <label class="lbl-exprt">Export open orders (excel) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i (click)="downloadExcel()" class="fa fa-download"></i></label>
  </div>

</div>
